import axiosBackend from "core/api/backend";

export default function LoadQueriesListFromPlayground({
    appUUID,
}) {
    return axiosBackend({
        method: "POST",
        url: `/service/query-playground/${appUUID}/`,
    })
}